export type Consultor = {
  slug: string;
  nome: string;
  primeiroNome: string;
  whatsappRaw: string; // só dígitos, ex: 5515996505958
  whatsappDisplay: string; // formatado
  email: string;
  ghlTag: string;
};

export const CONSULTORES: Record<string, Consultor> = {
  renato: {
    slug: "renato",
    nome: "Renato Moraes",
    primeiroNome: "Renato",
    whatsappRaw: "5515996505958",
    whatsappDisplay: "+55 15 99650-5958",
    email: "renato@px3lab.com.br",
    ghlTag: "origem:consultor-renato",
  },
  // Fase 2 - já preparado:
  mary: {
    slug: "mary",
    nome: "Mary Oliveira",
    primeiroNome: "Mary",
    whatsappRaw: "5511924774894",
    whatsappDisplay: "+55 11 92477-4894",
    email: "mary@px3lab.com.br",
    ghlTag: "origem:consultor-mary",
  },
  monique: {
    slug: "monique",
    nome: "Monique Miranda",
    primeiroNome: "Monique",
    whatsappRaw: "5511934313883",
    whatsappDisplay: "+55 11 93431-3883",
    email: "monique@px3lab.com.br",
    ghlTag: "origem:consultor-monique",
  },
  vinicius: {
    slug: "vinicius",
    nome: "Vinícius Amaral",
    primeiroNome: "Vinícius",
    whatsappRaw: "5511992311361",
    whatsappDisplay: "+55 11 99231-1361",
    email: "vinicius@px3lab.com.br",
    ghlTag: "origem:consultor-vinicius",
  },
};

export const EVENTO_TAG = "evento:conafor-smart-2026";

export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Oi, vim do CONAFOR e quero garantir meus 5000 créditos no Cloud PhotoRF 2.0."
);

export function getWhatsappLink(c: Consultor) {
  return `https://wa.me/${c.whatsappRaw}?text=${WHATSAPP_MESSAGE}`;
}
